import { render, staticRenderFns } from "./SolanJournalsTTableStudentRow.vue?vue&type=template&id=b0b1d776&scoped=true&"
import script from "./SolanJournalsTTableStudentRow.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsTTableStudentRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsTTableStudentRow.vue?vue&type=style&index=0&id=b0b1d776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b1d776",
  null
  
)

export default component.exports